var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-sm text-grey-2 font-semibold uppercase"},[_vm._v("\n  "+_vm._s((_vm.getTotalPointsPrice + " " + (_vm.$t('Pts'))))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }